import QuotationRoutes from "./quotation-routes.component";

export default QuotationRoutes;
